/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/ColorConstants',[], function () {
    "use strict";

    var ColorConstants = {
        Klondike: 0x1FB9E8,
        Spider: 0xa45de8,
        FreeCell: 0xcc3d3d,
        Pyramid: 0xFB8B01,
        TriPeaks: 0x72B504,
        DailyChallenge: 0x026DBF,
        StarClub: 0x040C56
    };

    return ColorConstants;

});
